import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-setting-user-form',
  templateUrl: './setting-user-form.component.html',
  styleUrls: ['./setting-user-form.component.scss']
})
export class SettingUserFormComponent implements AfterViewInit {

  public data : any = {};
  public startingView = false;
  get canViewAs(): boolean { return !this.http.isViewingUser && this.consolidatedAccess.can_edit === true && !!this.data.uuid && !this.data.is_super_admin && !this.data.is_support; }
  async viewAsUser() {
    if (!this.canViewAs || this.startingView) return;
    this.startingView = true;
    try { await this.http.startViewAs(this.data.uuid); }
    finally { this.startingView = false; }
  }
  public permissions : any = [];
  public permissionSections: any[] = [];
  public consolidatedAccess = { enabled: false, can_edit: false };
  public shareholderAccess = { enabled: false, can_edit: false, data_scope: '', start_period: '2026-10' };
  public savingShareholder = false;
  public shareholderMessage = '';
  public savingConsolidated = false;
  public consolidatedMessage = '';
  public company_uuid : any = null;
  @ViewChild('f', { static: false }) f : NgForm

  constructor(private http: HttpService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private location: Location) { 

    const company_uuid: Observable<string> = this.route.params.pipe(map(p => p['company_uuid']));
    company_uuid.subscribe(val => {
      if(val && val != "null") {
        this.company_uuid = val;
      } else {
        this.company_uuid = null;
      }
    })
    
    const user_uuid: Observable<string> = this.route.params.pipe(map(p => p['user_uuid']));
    user_uuid.subscribe(val => {
      if(val) {
        this.initData(val);
      }
    }) 
  }

  initForm() {
    this.data = {status: 1, is_admin : 0, com_uuid: this.company_uuid};
    this.f.resetForm(this.data)
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    this.initForm();
  }

  async initData(uuid) {
    let rtn:any = await this.http.post("/admin/user/admin-get", {edit_user_uuid: uuid});
    if(rtn.user){
      this.data = rtn.user;
    }
    this.permissions = rtn.menus;
    this.consolidatedAccess = rtn.consolidated_wallet_access || { enabled: false, can_edit: false };
    this.shareholderAccess = rtn.unity_shareholder_access || { enabled: false, can_edit: false, data_scope: '', start_period: '2026-10' };
    this.buildPermissionSections();
  }

  buildPermissionSections() {
    this.permissionSections = this.permissions;
  }

  async saveShareholderAccess() {
    if (this.savingShareholder || !this.shareholderAccess.can_edit || !this.data.uuid) return;
    if (this.shareholderAccess.enabled && !this.shareholderAccess.data_scope) {
      this.shareholderMessage = 'Choose the report data scope.';
      return;
    }
    this.savingShareholder = true;
    this.shareholderMessage = '';
    try {
      const result: any = await this.http.post('/admin/user/unity-shareholder-access', {
        edit_user_uuid: this.data.uuid, enabled: this.shareholderAccess.enabled,
        data_scope: this.shareholderAccess.data_scope,
      });
      this.shareholderMessage = result?.status ? 'Unity shareholder access saved. The user must log in again.'
        : result?.message || 'Unable to save shareholder access.';
    } finally { this.savingShareholder = false; }
  }

  async saveConsolidatedAccess() {
    if (this.savingConsolidated || !this.consolidatedAccess.can_edit || !this.data.uuid) return;
    this.savingConsolidated = true;
    this.consolidatedMessage = '';
    try {
      const result: any = await this.http.post('/admin/user/consolidated-wallet-access', {
        edit_user_uuid: this.data.uuid, enabled: this.consolidatedAccess.enabled
      });
      this.consolidatedMessage = result?.status
        ? 'Consolidated access saved.' : result?.message || 'Unable to save consolidated access.';
    } finally {
      this.savingConsolidated = false;
    }
  }

  async submit() {
    this.data.permissions = this.permissions;
    const y = await this.http.post("/admin/user/update", this.data);

    if (!y['status']) {
      this.http.notify(y['message']);
      return;
    }

    this.location.back();

  }

  countSelected(permission: any): number {
    if (!permission || !permission.children) return 0;
    return permission.children.filter((m: any) => !!m.value).length;
  }

  selectAll(permission: any) {
    if (!permission || !permission.children) return;
    permission.children.forEach((m: any) => m.value = true);
  }

  clearAll(permission: any) {
    if (!permission || !permission.children) return;
    permission.children.forEach((m: any) => m.value = false);
  }

}
